
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-500 to-red-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="w-full h-16 mb-4 flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/3e2e1c40240cdeefb89461b25c4d74a9.jpg"
                alt="Goodys Streams"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/90 mb-6">
              Professional digital media support services providing expert device configuration, entertainment system optimization, and 24/7 technical assistance for all your home entertainment needs.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Useful Links</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#faq" className="text-white/80 hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Refund Policy</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Tutorials</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-whatsapp-line"></i>
                </div>
                <a href="https://wa.me/qr/QOVGSHQTONIKJ1" className="text-white/90 hover:text-white cursor-pointer">+44 7438 913933</a>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-telegram-line"></i>
                </div>
                <span className="text-white/90">Telegram</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <span className="text-white/90">support@goodysstreams.com</span>
              </li>
              <li className="flex items-start">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span className="text-white/90">Goodys Streams Ltd<br />London, UK</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/80 text-sm">©2024 Goodys Streams. All Rights Reserved.</p>
          <div className="mt-4 md:mt-0">
            <a href="https://readdy.ai/?ref=logo" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}